var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16V10M5 16V12.5M13 16V14M9.15 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H15C16.1046 20 17 19.1046 17 18V11.85M16 1L17 4L20 5L17 6L16 9L15 6L12 5L15 4L16 1Z",
    stroke: "black",
    strokeOpacity: 0.77,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsight);
export default __webpack_public_path__ + "static/media/icon-insight.d1c672824882c177221e6ce9fbf4c7a1.svg";
export { ForwardRef as ReactComponent };